<template>
    <ModalFormCard :action="action" :submittedCallback="submittedCallback" class="modal-default wide">
        <template #title>{{ isEdit ? 'Edit' : 'Create new' }} deal</template>

        <template #default="{ saving, errors }">
            <div class="!hidden">
                <BelongsContactDeal
                    v-if="!isEdit"
                    v-model:modelId="value.modelId"
                    v-model:modelType="value.modelType"
                    :canAddToDeal="false"
                    :defaultBelongsId="modelId"
                    :defaultBelongsType="modelType"
                />
            </div>

            <Select
                v-model:value="value.category_id"
                :class="[!isEdit ? '' : '']"
                :options="categoriesOptions"
                label="Deal category"
                name="category_id"
                placeholder="Deal category"
                selectClass="!bg-grey text-15"
            />

            <button v-if="!addName" class="flex items-center mt-3" type="button" @click="addName = true">
                <IconPlus class="stroke-black w-4.5 h-4.5" />
                <p class="pl-2 text-grey-900 text-14">Add a custom title</p>
            </button>

            <Input
                v-if="addName"
                ref="cName"
                v-model:value="value.name"
                class="mt-4"
                groupClass="bg-grey text-15"
                label="Deal title"
                name="name"
                placeholder="Custom name"
                :limit="30"
            >
                <template #right>
                    <button
                        type="button"
                        class="w-10 h-6 flex items-center justify-center"
                        @click="
                            () => {
                                addName = false
                                value.name = null
                            }
                        "
                    >
                        <IconClose class="stroke-black w-4.5 h-4.5" />
                    </button>
                </template>
            </Input>

            <Textarea
                v-model:value="value.summary"
                class="mt-4"
                groupClass="bg-grey text-15"
                label="Summary"
                name="summary"
                placeholder="What is this deal about?"
                rows="4"
            />

            <div class="grid lg:grid-cols-3 grid-cols-1 gap-4 mt-4">
                <Input
                    v-model:value="value.quoted"
                    :focusedClass="true"
                    :hideError="true"
                    groupClass="bg-grey text-15"
                    label="Revenue (£)"
                    name="quoted"
                    placeholder="£0.00"
                    @blur="blur"
                    @onKeyup="(event) => $help.delay(blur(event), 300)"
                >
                    <template #preview>
                        <p>{{ $help.dp(value.quoted, 0) }}</p>
                    </template>
                </Input>

                <Input
                    v-model:value="value.profit"
                    :focusedClass="true"
                    :hideError="true"
                    groupClass="bg-grey text-15"
                    label="Profit (£)"
                    name="profit"
                    placeholder="£0.00"
                    @blur="blur"
                    @onKeyup="(event) => $help.delay(blur(event), 300)"
                >
                    <template #preview>
                        <p>{{ $help.dp(value.profit, 0) }}</p>
                    </template>
                </Input>

                <Input
                    v-model:value="value.margin"
                    :focusedClass="true"
                    :hideError="true"
                    groupClass="bg-grey text-15"
                    label="Margin (%)"
                    name="margin"
                    placeholder="0%"
                    @blur="blur"
                    @onKeyup="(event) => $help.delay(blur(event), 300)"
                >
                    <template #preview>
                        <p>{{ $help.dp(value.margin, 0, false) }}%</p>
                    </template>
                </Input>
            </div>

            <Error v-if="errors" :error="errors.has('quoted')" />
            <Error v-if="errors" :error="errors.has('profit')" />
            <Error v-if="errors" :error="errors.has('margin')" />

            <div class="grid lg:grid-cols-2 grid-cols-1 gap-4 mt-4">
                <!-- <Select
					v-model:value="value.status"
					:options="[
						{
							value: 'quote',
							html: `<div class=&quot;items-center flex&quot;>
								<div class=&quot;w-2 h-2 rounded-full bg-red-500&quot;></div>
								<p class=&quot;pl-1.5 text-14 capitalize&quot;>Quoted</p>
							</div>`,
						},
						{
							value: 'won',
							html: `<div class=&quot;items-center flex&quot;>
								<div class=&quot;w-2 h-2 rounded-full bg-green-500&quot;></div>
								<p class=&quot;pl-1.5 text-14 capitalize&quot;>Won</p>
							</div>`,
						},
						{
							value: 'complete',
							html: `<div class=&quot;items-center flex&quot;>
								<div class=&quot;w-2 h-2 rounded-full bg-blue-600&quot;></div>
								<p class=&quot;pl-1.5 text-14 capitalize&quot;>Completed</p>
							</div>`,
						},
						{
							value: 'lost',
							html: `<div class=&quot;items-center flex&quot;>
								<div class=&quot;w-2 h-2 rounded-full bg-grey-800&quot;></div>
								<p class=&quot;pl-1.5 text-14 capitalize&quot;>Lost</p>
							</div>`,
						},
					]"
					label="Deal stage"
					menuClass="!bg-grey"
					name="status"
					selectClass="!bg-grey"
				/> -->

                <Select
                    :options="stages"
                    v-model:value="value.status"
                    label="Deal stage"
                    placeholder="Select stage"
                    menuClass="!bg-grey"
                    name="status"
                    selectClass="!bg-grey"
                    valueKey="id"
                    :disabled="value.state != null"
                >
                    <template #option="{ option, selected }">
                        <div class="flex items-center">
                            <div
                                class="w-2 h-2 rounded-full mr-2 transition-all duration-300 ease-in-out"
                                v-if="option.color != undefined"
                                :style="{ backgroundColor: option.color }"
                                :class="{
                                    'opacity-30': value.state != null,
                                }"
                            />
                            <p class="text-15 font-normal">{{ $help.capitalizeFirstLetter(option.name) }}</p>
                        </div>
                    </template>
                </Select>

                <Select
					v-model:value="value.state"
					class="col-span-1"
					label="Deal status"
					menuClass="!bg-grey"
					name="temperature"
					placeholder="Select category"
					selectClass="!bg-grey text-15"
                    :options="[
                        { name: 'Active', value: null },
                        { name: 'Won', value: 1, color: 'bg-green-500' },
                        { name: 'Lost', value: -1, color: 'bg-red-700' },
                    ]"
                >
                    <template #option="{ option, selected }">
                        <div class="flex items-center">
                            <div class="h-2 w-2 rounded-full mr-2" v-if='option.color' :class='[option.color]' />
                            <p class="">{{ $help.capitalizeFirstLetter(option.name) }}</p>
                        </div>
                    </template>
                </Select>

                <InputDropdownDatePicker
                    :apply="false"
                    :tab-index="3"
                    class="col-span-1"
                    input-class="!h-12"
                    label="Deal created on"
                    name="created_at"
                    placeholder="DD/MM/YYYY"
                />
            </div>

            <div class="modal-buttons">
                <ButtonSaving :disabled="saving" class="button-black default"> {{ isEdit ? 'Update' : 'Create' }} deal </ButtonSaving>

                <button
                    :disabled="saving"
                    class="default button-purple"
                    v-if="!isEdit && $route.name != 'deal'"
                    name="redirect_after"
                    value="1"
                >
                    {{ isEdit ? 'Update' : 'Create' }} and view
                </button>

                <button
                    type="button"
                    @click="
                        () => {
                            $event.$emit('modal-open', {
                                view: 'deal-delete',
                                editingModel: editingModel,
                            })
                        }
                    "
                    :disabled="saving"
                    class="default button-purple"
                    v-else
                >
                    Delete deal
                </button>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Deal from '~/models/deal.js'
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    created() {
        this.setup(Deal)

        if (this.value.status == null) {
            this.value.status = this.stages[0].id
        }

        if (!this.isEdit && this.options.dealOrigin != null) {
            if (this.options.dealOrigin?.call?.ai?.body != null) {
                this.value.summary = JSON.parse(this.options.dealOrigin?.call?.ai?.body).description || ''
            }

            let title = this.stages.find((a) => a.name.toLowerCase() == String(this.options.dealOrigin.title).toLowerCase())

            if (title != null) {
                this.value.category_id = title.id
            }
        }
    },

    data() {
        return {
            addName: this.editingModel?.name != null ? true : false,
        }
    },

    methods: {
        submittedCallback(res, event) {
            this.redirectAfterSubmit(event, '/deal/' + res.deal_id)
            
            if (this.value.state == -1) {
                this.editingModel.updateStatus('lost')
            } else {
                this.$event.$emit('modal-form-completed')
                this.$event.$emit('modal-close')
            }
        },

        focus(event) {
            // switch (event.target.name) {
            // 	case 'quoted':
            // 		if (this.value.quoted != '' && this.value.quoted != null) {
            // 			this.value.quoted = this.$help.dpToFloat(this.value.quoted)
            // 		}
            // 	break;
            // 	case 'profit':
            // 		if (this.value.profit != '' && this.value.profit != null) {
            // 			this.value.profit = this.$help.dpToFloat(this.value.profit)
            // 		}
            // 	break;
            // 	case 'margin':
            // 		if (this.value.margin != '' && this.value.margin != null) {
            // 			this.value.margin = this.$help.dpToFloat(this.value.margin)
            // 		}
            // 	break;
            // }
        },

        blur(event) {
            let canUpdate = false

            if ((this.value.margin != '' ? 1 : 0) + (this.value.profit != '' ? 1 : 0) + (this.value.quoted != '' ? 1 : 0) >= 2) {
                canUpdate = true
            }

            let q = this.value.quoted == '' || this.value.quoted == null ? '' : this.$help.dpToFloat(this.value.quoted, 2)
            let p = this.value.profit == '' || this.value.profit == null ? '' : this.$help.dpToFloat(this.value.profit, 2)
            let m = this.value.margin == '' || this.value.margin == null ? '' : this.$help.dpToFloat(this.value.margin, 2)

            if (canUpdate) {
                switch (true) {
                    case event.target.name == 'quoted':
                        if (p == '') {
                            p = (q / 100) * m
                        } else {
                            m = (100 / q) * p
                        }
                        break
                    case event.target.name == 'profit':
                        if (q == '') {
                            q = (p / m) * 100
                        } else {
                            //  (m == null)
                            m = (100 / q) * p
                        }
                        break
                    case event.target.name == 'margin':
                        if (q == '') {
                            q = (p / m) * 100
                        } else {
                            p = (q / 100) * m
                        }
                        break
                }
            }

            this.value.quoted = q != '' ? q : ''
            this.value.profit = p != '' ? p : ''
            this.value.margin = m != '' ? m : ''

            if (event.target.name != 'quoted') {
                // this.value.quoted = q != '' ? this.$help.dp(q, 2, false).replace('.00', '') : ''
                this.value.quoted = q != '' ? this.$help.dpToFloat(q, 2) : ''
                
            }

            if (event.target.name != 'profit') {
                // this.value.profit = p != '' ? this.$help.dp(p, 2, false).replace('.00', '') : ''
                this.value.profit = p != '' ? this.$help.dpToFloat(p, 2) : ''
            }

            if (event.target.name != 'margin') {
                // this.value.margin = m != '' ? String(this.$help.dpToFloat(m).toFixed(2)).replace('.00', '') : ''
                this.value.margin = m != '' ? this.$help.dpToFloat(m, 2) : ''
            }
        },

        blurold(event) {
            // let q = this.value.quoted == '' ? null : this.$help.dpToFloat(this.value.quoted);
            // let p = this.value.profit == '' ? null : this.$help.dpToFloat(this.value.profit);
            // let m = this.value.margin == '' ? null : this.$help.dpToFloat(this.value.margin);
            // this.value.quoted = q != null ? this.$help.dp(q, 2, false) : '';
            // this.value.profit = p != null ? this.$help.dp(p, 2, false) : '';
            // this.value.margin = m != null ? this.$help.dpToFloat(m).toFixed(2) : ''
        },
    },

    computed: {
        stages() {
            return this.$authSanctum.getUser().deal_stages
        },

        deal_categories() {
            return this.$authSanctum.getUser().deal_categories
        },

        categoriesOptions() {
            return this.deal_categories.map((n) => {
                return {
                    value: n.id,
                    html: this.$help.capitalizeFirstLetter(n.name),
                }
            })
        },
    },
}
</script>
